module.exports = __webpack_public_path__ + "static/media/purpleEmail.6de6d0d2.svg";